import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColorRoll: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconColorRoll"><Path d="M6.5 3.5H20.5V10.5H6.5V7V3.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 7H3.5V13.5H13V16C14.3807 16 15.5 17.1193 15.5 18.5V21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M13 16C11.6193 16 10.5 17.1193 10.5 18.5V21.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconColorRoll;
